import React, { useState, useEffect } from 'react';
import { Card, Button, Form, Alert, Spinner, Toast } from 'react-bootstrap';
import axios from 'axios';

const UafeEvidencia = ({ formularioId, onCalificacionChange }) => {
  const [archivo, setArchivo] = useState(null);
  const [califica, setCalifica] = useState(null);
  const [evidenciaExistente, setEvidenciaExistente] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cargandoDatos, setCargandoDatos] = useState(true);
  const [error, setError] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');

  const token = localStorage.getItem('token');

  useEffect(() => {
    cargarEvidenciaExistente();
  }, [formularioId]);

  const cargarEvidenciaExistente = async () => {
    try {
      setCargandoDatos(true);
      const response = await axios.get(
        `https://apiprov.conduto.com.ec/api/uafe/evidencia/${formularioId}`,
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${token}` },
          timeout: 10000
        }
      );

      if (response.data && response.data.id_evidencia) {
        setEvidenciaExistente(response.data);
        setCalifica(response.data.califica);
        if (onCalificacionChange) {
          onCalificacionChange(response.data.califica);
        }
      }
    } catch (error) {
      console.error('Error cargando evidencia:', error);
    } finally {
      setCargandoDatos(false);
    }
  };

  const mostrarMensaje = (mensaje, variante = 'success') => {
    setToastMessage(mensaje);
    setToastVariant(variante);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const handleArchivoChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      if (file.size > 5 * 1024 * 1024) {
        setError('El archivo es demasiado grande. Máximo 5MB');
        setArchivo(null);
        return;
      }
      setArchivo(file);
      setError('');
    } else {
      setError('Por favor, seleccione un archivo PDF válido');
      setArchivo(null);
    }
  };

  const handleCalificaChange = (e) => {
    const valor = e.target.value === 'true';
    setCalifica(valor);
    if (onCalificacionChange) {
      onCalificacionChange(valor);
    }
  };

  const handleSubmit = async () => {
    if (califica === null) {
      setError('Debe seleccionar si el proveedor califica o no');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const formData = new FormData();
      formData.append('id_formulario', formularioId.toString());
      formData.append('califica', califica ? 'true' : 'false');

      if (archivo) {
        formData.append('archivo', archivo);
      }

      const response = await axios.post(
        'https://apiprov.conduto.com.ec/api/uafe/evidencia',
        formData,
        {
          withCredentials: true,
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          },
          timeout: 30000
        }
      );

      if (response.data.success) {
        mostrarMensaje('Evidencia UAFE guardada correctamente');
        setEvidenciaExistente(response.data.data);
        setArchivo(null);
        const fileInput = document.getElementById('uafe-archivo');
        if (fileInput) fileInput.value = '';
      }
    } catch (error) {
      console.error('Error guardando evidencia:', error);
      let errorMessage = 'Error al guardar la evidencia';

      if (error.response?.data?.detail) {
        if (typeof error.response.data.detail === 'string') {
          errorMessage = error.response.data.detail;
        } else if (Array.isArray(error.response.data.detail)) {
          errorMessage = error.response.data.detail.map(d => d.msg).join(', ');
        } else if (typeof error.response.data.detail === 'object') {
          errorMessage = JSON.stringify(error.response.data.detail);
        }
      }

      setError(errorMessage);
      mostrarMensaje(errorMessage, 'danger');
    } finally {
      setLoading(false);
    }
  };

  const handleEliminar = async () => {
    if (!window.confirm('¿Está seguro de eliminar esta evidencia?')) return;

    setLoading(true);
    try {
      await axios.delete(
        `https://apiprov.conduto.com.ec/api/uafe/evidencia/${formularioId}`,
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${token}` },
          timeout: 10000
        }
      );

      setEvidenciaExistente(null);
      setCalifica(null);
      setArchivo(null);
      if (onCalificacionChange) {
        onCalificacionChange(null);
      }
      mostrarMensaje('Evidencia eliminada correctamente');
    } catch (error) {
      console.error('Error eliminando evidencia:', error);
      let errorMessage = 'Error al eliminar la evidencia';

      if (error.response?.data?.detail) {
        if (typeof error.response.data.detail === 'string') {
          errorMessage = error.response.data.detail;
        } else if (Array.isArray(error.response.data.detail)) {
          errorMessage = error.response.data.detail.map(d => d.msg).join(', ');
        }
      }

      setError(errorMessage);
      mostrarMensaje(errorMessage, 'danger');
    } finally {
      setLoading(false);
    }
  };

  const abrirDocumento = () => {
    if (evidenciaExistente?.ruta_archivo) {
      const url = `https://apiprov.conduto.com.ec/api/documentos/visualizar/${encodeURIComponent(evidenciaExistente.ruta_archivo)}`;
      window.open(url, '_blank');
    }
  };

  if (cargandoDatos) {
    return (
      <Card className="mb-4">
        <Card.Body className="text-center">
          <Spinner animation="border" size="sm" />
          <span className="ms-2">Cargando evidencia UAFE...</span>
        </Card.Body>
      </Card>
    );
  }

  return (
    <>
      <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 9999 }}>
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
          style={{
            backgroundColor: toastVariant === 'success' ? '#198754' : '#dc3545',
            color: '#ffffff',
            minWidth: 220
          }}
        >
          <Toast.Body className="d-flex align-items-center gap-2">
            <span style={{ fontSize: 22, color: '#ffffff' }}>
              <i className={`bi bi-${toastVariant === 'success' ? 'check-circle-fill' : 'exclamation-circle-fill'}`}></i>
            </span>
            <span>{toastMessage}</span>
          </Toast.Body>
        </Toast>
      </div>

      <Card className="mb-4 shadow-sm border-0">
        <Card.Header className="bg-light">
          <h5 className="mb-0">Verificación UAFE</h5>
        </Card.Header>
        <Card.Body>
          {error && (
            <Alert variant="danger" onClose={() => setError('')} dismissible>
              {error}
            </Alert>
          )}

          {!evidenciaExistente?.ruta_archivo && (
            <Form.Group className="mb-3">
              <Form.Label><strong>Evidencia (PDF)</strong></Form.Label>
              <Form.Control
                id="uafe-archivo"
                type="file"
                accept=".pdf"
                onChange={handleArchivoChange}
                disabled={loading}
              />
              <Form.Text className="text-muted">
                Suba el PDF de la evidencia (máximo 5MB).
              </Form.Text>
            </Form.Group>
          )}

          {evidenciaExistente?.ruta_archivo && (
            <div className="mb-3">
              <Form.Label><strong>Documento actual:</strong></Form.Label>
              <div>
                <Button
                  variant="link"
                  className="p-0 text-start text-decoration-none"
                  onClick={abrirDocumento}
                >
                  Ver evidencia actual
                </Button>
              </div>
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label><strong>¿El proveedor cumple el proceso de lavado de activos?</strong></Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                id="califica-si"
                label="Sí, cumple"
                value="true"
                checked={califica === true}
                onChange={handleCalificaChange}
                disabled={loading}
              />
              <Form.Check
                inline
                type="radio"
                id="califica-no"
                label="No cumple"
                value="false"
                checked={califica === false}
                onChange={handleCalificaChange}
                disabled={loading}
              />
            </div>
            <Form.Text className="text-muted">
              Si selecciona "No cumple", automáticamente la calificación del proveedor será 0
            </Form.Text>
          </Form.Group>

          <div className="d-flex gap-2">
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={loading || califica === null}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Guardando...
                </>
              ) : (
                evidenciaExistente ? 'Actualizar Calificación' : 'Guardar Evidencia'
              )}
            </Button>

            {evidenciaExistente && (
              <Button
                variant="danger"
                onClick={handleEliminar}
                disabled={loading}
              >
                Eliminar Evidencia
              </Button>
            )}
          </div>

          {evidenciaExistente && (
            <div className="mt-3 text-success">
              <i className="bi bi-check-circle-fill me-1"></i>
              Evidencia guardada correctamente
              {evidenciaExistente.califica ? (
                <span className="ms-2 badge bg-success">Proveedor cumple el proceso de lavado de activos</span>
              ) : (
                <span className="ms-2 badge bg-danger">Proveedor NO cumple el proceso de lavado de activos</span>
              )}
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default UafeEvidencia;